import Modal from 'react-bootstrap/Modal';
import useModal from "@hooks/ModalHook";
import { WalletStatus, useWallet } from '@terra-money/wallet-provider';
import { useBaaanggg } from '@hooks/BaaangggHook';
import { useEffect, useState } from 'react';
import useAlert from '@hooks/AlertHook';
import { useAccount } from '@contexts/AccountContext';

export function RegisterModal() {
    const { showModal, closeModal, modalId } = useModal()
    const { openModal } = useModal()
    const { status, disconnect } = useWallet()
    const { address, refreshAccount } = useAccount()
    const baaanggg = useBaaanggg()
    const [error, setError] = useState("")
    const [username, setUsername] = useState("")
    const alert = useAlert()


    const handleWalletStatus = async () => {
        if (address) {
            const response = await baaanggg.user.isRegistered(address)
            if (!response.isRegistered) {
                openModal("register")
            }
        }
    }

    const handleRegister = async () => {
        if (!username) {
            setError("Please enter username")
            return;
        }
        setError("")

        try {
            if (!address) {
                alert.failed("Cannot fetch wallet address, try again later")
                return;
            }
            alert.loading("Create account")
            await baaanggg.auth.createAccount({
                username,
                walletAddress: address
            })
            alert.success("Your account successfully created")
            localStorage.removeItem("token")
            refreshAccount()
        } catch (e) {
            if (e instanceof Error) alert.failed(e.message)
            closeRegister()
        }
    }

    const closeRegister = () => {
        disconnect()
        closeModal()
    }


    useEffect(() => {
        if (status === WalletStatus.WALLET_CONNECTED) handleWalletStatus()
    }, [status, address])


    return <>
        <Modal show={showModal && modalId === "register"} dialogClassName="max-w-lg">
            <Modal.Header>
                <Modal.Title>Register Your Account</Modal.Title>
                <button type="button" className="btn-close" onClick={() => closeRegister()} aria-label="Close">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="h-6 w-6 fill-jacarta-700 dark:fill-white"
                    >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                        />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body className="p-6 text-center grid grid-cols-1 gap-3">
                <div className="container">
                    <input
                        onChange={e => setUsername(e.target.value)}
                        type="text"
                        className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                        placeholder="Enter username"
                        required
                    />
                    <p className='mt-2 mb-4 text-red'>{error}</p>
                    <button onClick={handleRegister} className="rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
                        Register
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    </>
}